import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { ParentInsertData } from '../../../types/users'
import { useApiPostMutation } from '../useApi'

type InsertParentResult = {
  insertedId: number
}

export const useParentInsert = () => {
  const queryClient = useQueryClient()

  // const mutation = useApiPostMutation<ApiResponse<InsertParentResult>, ParentInsertData>()
  const mutation = useApiPostMutation<InsertParentResult, ParentInsertData>()

  return {
    ...mutation,
    mutateAsync: async (data: ParentInsertData) => {
      const result = await mutation.mutateAsync({
        url: '/users/insert-parent',
        data,
      })
      // 부모 목록 및 관련 캐시 무효화
      queryClient.invalidateQueries({ queryKey: ['parentsList'] })
      queryClient.invalidateQueries({ queryKey: ['parentDetail', data.ID] })
      return result
    },
    mutate: (data: ParentInsertData) => {
      mutation.mutate(
        {
          url: '/users/insert-parent',
          data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['parentsList'] })
            queryClient.invalidateQueries({
              queryKey: ['parentDetail', data.ID],
            })
          },
        }
      )
    },
  }
}
